import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";
import {
  setSynchronization,
  setSynchronizationRole,
  setSynchronizationEntity
} from "Actions";
import { Switch, Tooltip } from "antd";
import styles from "./ParameterSettings.local.scss";

class SynchronizationParameters extends Component {
  constructor(props) {
    super(props);
    let parameterSettings = this.props.data;
    this.state = {
      year: null,
      synchronization: parameterSettings.synchro,
      synchronizationRole: parameterSettings.synchroRole,
      synchronizationEntity: parameterSettings.synchroEntity
    };
  }

  handleSynchronizationChange = () => {
    const { dispatch } = this.props;
    dispatch(setSynchronization(!this.state.synchronization));
    if (this.state.synchronization) {
      dispatch(setSynchronizationRole(false));
      dispatch(setSynchronizationEntity(false));
    }
    this.setState({
      synchronization: !this.state.synchronization,
      synchronizationRole: this.state.synchronization
        ? false
        : this.state.synchronizationRole,
      synchronizationEntity: this.state.synchronization
        ? false
        : this.state.synchronizationEntity
    });
    this.handleCheckDisabledSave(
      !this.state.synchronization,
      this.state.synchronizationRole,
      this.state.synchronizationEntity
    );
  };

  handleSynchronizationRoleChange = () => {
    const { dispatch } = this.props;
    dispatch(setSynchronizationRole(!this.state.synchronizationRole));
    this.setState({
      synchronizationRole: !this.state.synchronizationRole
    });
    this.handleCheckDisabledSave(
      this.state.synchronization,
      !this.state.synchronizationRole,
      this.state.synchronizationEntity
    );
  };

  handleSynchronizationEntityChange = () => {
    const { dispatch } = this.props;
    dispatch(setSynchronizationEntity(!this.state.synchronizationEntity));
    this.setState({
      synchronizationEntity: !this.state.synchronizationEntity
    });
    this.handleCheckDisabledSave(
      this.state.synchronization,
      this.state.synchronizationRole,
      !this.state.synchronizationEntity
    );
  };

  handleCheckDisabledSave = (
    synchronization,
    synchronizationRole,
    synchronizationEntity
  ) => {
    if (synchronization && !synchronizationRole && !synchronizationEntity) {
      this.props.handleDisabledSave(true);
    } else {
      this.props.handleDisabledSave(false);
    }
  };

  render() {
    return (
      <div className={styles.tab_synchronization}>
        <div className={styles.header}>
          <span>
            {_("parameterSynchronization")}
            <Tooltip
              placement="bottom"
              title={
                <div style={{ textAlign: "justify" }}>
                  <div>{_("La synchronization est depuis Syneton ")}</div>
                </div>
              }
            >
              <img
                data-for="info__undefined"
                data-tip=""
                className={styles.info_icon}
                src="/img/icons/info.svg"
                alt=""
                currentitem="false"
              />
            </Tooltip>
          </span>
          <div
            className={classnames(styles.etat_block, styles.checkbox_container)}
          >
            <span
              style={{
                color: this.state.synchronization ? "#18a0fb" : "#919191"
              }}
            >
              {this.state.synchronization ? _("ACTIVATED") : _("DEACTIVATED")}
            </span>
            <Switch
              checked={this.state.synchronization}
              onChange={() => this.handleSynchronizationChange()}
            />
          </div>
        </div>
        <div>
          <div className={styles.body}>
            <div className={styles.bar}>
              <div>
                <span className={styles.title}>{_("manageRole")}</span>
              </div>
              <div>
                <span className={styles.info}>
                  {_("manageRolesCollaboratorsOnFiles")}
                </span>
              </div>
            </div>
            <div
              className={classnames(
                styles.etat_block,
                styles.checkbox_container
              )}
            >
              <span
                style={{
                  color: this.state.synchronizationRole ? "#18a0fb" : "#919191"
                }}
              >
                {this.state.synchronizationRole
                  ? _("ACTIVATED")
                  : _("DEACTIVATED")}
              </span>
              <Switch
                checked={this.state.synchronizationRole}
                disabled={!this.state.synchronization}
                onChange={() => this.handleSynchronizationRoleChange()}
              />
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.bar}>
              <div>
                <span className={styles.title}>{_("manageEntity")}</span>
              </div>
              <div>
                <span className={styles.info}>
                  {_("ManageClientEntityRelationships")}
                </span>
              </div>
            </div>
            <div
              className={classnames(
                styles.etat_block,
                styles.checkbox_container
              )}
            >
              <span
                style={{
                  color: this.state.synchronizationEntity
                    ? "#18a0fb"
                    : "#919191"
                }}
              >
                {this.state.synchronizationEntity
                  ? _("ACTIVATED")
                  : _("DEACTIVATED")}
              </span>
              <Switch
                checked={this.state.synchronizationEntity}
                disabled={!this.state.synchronization}
                onChange={() => this.handleSynchronizationEntityChange()}
              />
            </div>
          </div>
          <div className={styles.message_info}>
            <span>*** {_("messageInfoSynchronization")}</span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  parameterSettings: state.parameterSettings
});

export default connect(mapStateToProps)(SynchronizationParameters);



// WEBPACK FOOTER //
// ./src/components/ParameterSettings/SynchronizationParameters.js